class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.mobileMenu = document.querySelector('[aria-controls="main-header--mobile-nav"]');
    this.mobileMenuContent = document.querySelector('.mobile-dropdown');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener('click',this.onSummaryClick.bind(this));
    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    const target = event.target.closest('span')?.dataset.open ?? 'menu';
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event,target);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event, target) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', target);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');
    document.body.classList.add('search-open');
    this.mobileMenu.classList.remove('active')
    this.mobileMenu.setAttribute('aria-expanded', false)
    this.mobileMenuContent.classList.remove('active')

    if (target == "search") {
      trapFocus(
        this.detailsContainer.querySelector('[tabindex="-1"]'),
        this.detailsContainer.querySelector('input:not([type="hidden"])')
        );
      }
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    this.querySelector('.submenu__item.is-active')?.classList.remove('is-active');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('search-open');
  }
}

customElements.define('details-modal', DetailsModal);

const mobileMenu = document.querySelector('[aria-controls="main-header--mobile-nav"]');
const mobileMenuContent = document.querySelector('.mobile-dropdown')
mobileMenu.addEventListener('click', function(){
  if (document.body.classList.contains('search-open')){

    document.querySelector('.header__search.mobile details').removeAttribute('open');

    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('search-open');

    mobileMenu.classList.add('active')
    mobileMenu.setAttribute('aria-expanded', true)
    mobileMenuContent.classList.add('active')
  }
})